import React from 'react';
import { Container } from 'reactstrap';

const Footer = (props) => {
    return (
        <div className="footer" role="contentinfo">
            <Container>
                <div>
                    <p>
                        Alignment Health Plan is an HMO, HMO POS, HMO C-SNP, HMO D-SNP and PPO plan
                        with a Medicare contract and a contract with the California, Nevada, North
                        Carolina and Texas Medicaid programs. Enrollment in Alignment Health Plan
                        depends on contract renewal. Alignment Health Plan complies with applicable
                        federal civil rights laws and does not discriminate on the basis of race,
                        color, national origin, age, disability, or sex.{' '}
                        <strong>
                            <a
                                id="disclaimer-link"
                                href={`https://www.alignmenthealthplan.com/about-us/terms-of-use`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Click here to read the full disclaimer.
                            </a>
                        </strong>
                    </p>
                </div>
                <div className="metadata-container">
                    <div>
                        <span>
                            ©Copyright {new Date().getFullYear()} Alignment Health Plan. All Rights
                            Reserved
                        </span>
                    </div>
                    <div>
                        <span>Page last updated on January 2 | {'Y0141_25277EN_M'}</span>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Footer;

export { Footer };

Footer.propTypes = {};
